import { render, staticRenderFns } from "./EduDash.vue?vue&type=template&id=85f524a4&scoped=true&"
import script from "./EduDash.vue?vue&type=script&lang=js&"
export * from "./EduDash.vue?vue&type=script&lang=js&"
import style0 from "./EduDash.vue?vue&type=style&index=0&id=85f524a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f524a4",
  null
  
)

export default component.exports